import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

export const MODAL_SIZES = {
  SMALL: 'sm',
  NORMAL: 'md',
  LG: 'lg'
};

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

function Modal({children, fullScreen, isOpened, onClose, size, Transition, title}) {
  return (
    <Dialog
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      open={isOpened}
      scroll="body"
      maxWidth={size}
      onClose={onClose}
      disableEscapeKeyDown={false}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      {!fullScreen && <DialogTitle onClose={onClose}>{title}</DialogTitle>}
      {fullScreen ? children : <DialogContent>{children}</DialogContent>}
    </Dialog>
  );
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
    PropTypes.array,
    PropTypes.node
  ]),
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  fullScreen: PropTypes.bool,
  Transition: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
  size: PropTypes.oneOf(Object.values(MODAL_SIZES)),
  title: PropTypes.string
};

Modal.defaultProps = {
  onClose: null,
  size: MODAL_SIZES.NORMAL,
  fullScreen: false,
  Transition: Fade,
  children: null,
  title: ''
};

export default Modal;
